import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=11517c4e&scoped=true"
import script from "./PreviewCard.vue?vue&type=script&lang=js"
export * from "./PreviewCard.vue?vue&type=script&lang=js"
import style0 from "./PreviewCard.vue?vue&type=style&index=0&id=11517c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11517c4e",
  null
  
)

export default component.exports